/* eslint-disable max-len */
export const selectIsAdManagerInitialized = state => state.adv?.isAdManagerInitialized

export const selectCategoryAdUnitsToInitialize = state => state.adv?.adUnits?.toBeInitialized
